import { createSlice, current } from '@reduxjs/toolkit';
import { getDetailsCart, getWebSectionForEndpoint } from '../libs/helpers';

export const cartSlice = createSlice({
  name: 'cart',
  initialState: { itemsCart: [], isShowed: false, loader: false },
  reducers: {
    setLoader: (state, action) => {
      return { ...state, loader: action.payload };
    },
    resetCartItems: (state, action) => {
      let cartSite = localStorage.getItem('site');
      localStorage.setItem(`cart-${cartSite}`, window.btoa(JSON.stringify([])));
      return {
        ...state,
        itemsCart: [],
        itemsCount: 0,
        totalPrice: parseFloat(0.0).toFixed(1),
      };
    },
    fetchCartItems: (state, action) => {
      let iniConfig = action.payload;
      let count = 0;
      let itemsCart = [];

      let cartSite = localStorage.getItem('site');
      if (localStorage.getItem(`cart-${cartSite}`)) {
        itemsCart = JSON.parse(window.atob(localStorage.getItem(`cart-${cartSite}`)));
        itemsCart.forEach((item) => {
          count = count + 1;
        });
      }
      return {
        ...current(state),
        ini: iniConfig,
        itemsCart: itemsCart,
        itemsCount: count,
        ...getDetailsCart(itemsCart),
      };
    },
    deleteCartItem: (state, action) => {
      let currentState = current(state);
      let codeItem = action.payload;
      let newArray = [];

      newArray = currentState.itemsCart.filter(
        (i) => i.item.SItemCode !== codeItem
      );
      let cartSite = localStorage.getItem('site');
      localStorage.setItem(`cart-${cartSite}`, window.btoa(JSON.stringify(newArray)));
      return {
        ...currentState,
        itemsCart: newArray,
        itemsCount: newArray.length,
        ...getDetailsCart(newArray),
      };
    },
    setItemToCart: (state, action) => {
      let currentState = current(state);
      let newListItemsCart = [...currentState.itemsCart];
      let newItemToCart = action.payload.item;
      let Exist = false;

      let newItems = newListItemsCart.map((item) => {
        if (item.item.SItemCode === newItemToCart.SItemCode) {
          Exist = true;
          if (action.payload.onList === true) {
            if (item.item.YnAllowFractionalSale === 1) {
              let totalItems =
                parseFloat(item.totalItems) +
                parseFloat(action.payload.totalItems);
              item = { ...item, totalItems: totalItems };
            } else {
              let totalItems =
                item.totalItems + parseInt(action.payload.totalItems);
              item = { ...item, totalItems: totalItems };
            }
          } else {
            item = { ...item, totalItems: action.payload.totalItems };
          }
        }
        return item;
      });
      newListItemsCart = newItems;
      if (!Exist) {
        newListItemsCart.push(action.payload);
      }
      let cartSite = localStorage.getItem('site');
      localStorage.setItem(
        `cart-${cartSite}`,
        window.btoa(JSON.stringify(newListItemsCart))
      );

      return {
        ...currentState,
        itemsCart: newListItemsCart,
        itemsCount: newListItemsCart.length,
        ...getDetailsCart(newListItemsCart),
      };
    },
  },
});

export const setCartToSessionSync = (obj) => async (dispatch, getState) => {
  dispatch(setLoader(true));

  let paramForForm = JSON.stringify(obj);
  let user = {};
  if (getState().site.user !== undefined && getState().site.user !== null) {
    user = JSON.stringify({
      Email: getState().site.user.Email,
      FullName: getState().site.user.fullName,
      Name: getState().site.user.FName,
      LastName: getState().site.user.LName1,
    });
  } else {
    user = '';
  }

  var form = document.createElement('form');
  document.body.appendChild(form);
  var element1 = document.createElement('input');
  var element2 = document.createElement('input');
  form.method = 'POST';
  form.action = `${getState().site.initialConfig.urlAPI}/RoyalMarket/${getWebSectionForEndpoint(
    getState().site.initialConfig.WebSection
  )}/Shopping/InformationPayV2`;
  element1.value = paramForForm;
  element1.name = 'Data';
  element1.type = 'hidden';
  element2.value = user;
  element2.name = 'UserData';
  element2.type = 'hidden';
  form.appendChild(element1);
  form.appendChild(element2);
  dispatch(resetCartItems());
  form.submit();
};

export const {
  fetchCartItems,
  setItemToCart,
  deleteCartItem,
  setLoader,
  resetCartItems,
} = cartSlice.actions;
export const selectItemsCart = (state) => state.cart.itemsCart;
export default cartSlice.reducer;
